import {
  getFirstResultItem,
  getResultMessage,
  isSuccessfulResult,
} from './clientEntryContracts';

export const CLIENT_MARKETPLACE_PAYMENT_ITEM_NAME = 'ClientCommandWorkspace';

export const CLIENT_MARKETPLACE_PAYMENT_OPERATIONS = Object.freeze({
  load: 'LoadMarketplacePayments',
  activate: 'ActivateMarketplacePayment',
  delete: 'DeleteMarketplacePayment',
});

export const buildClientMarketplacePaymentRequest = ({
  clientId,
  currentEnvironment,
  searchText = '',
  clientProductOfferId = '',
}) => ({
  ClientId: clientId,
  CurrentEnvironment: currentEnvironment,
  MarketplacePaymentRequest: {
    SearchText: String(searchText || '').trim(),
    ClientProductOfferId: String(clientProductOfferId || '').trim(),
  },
});

export const runClientMarketplacePaymentOperation = async (
  manager,
  operationName,
  item,
  fallbackMessage,
) => {
  if (!manager?.RunOperation) throw new Error(fallbackMessage);
  const result = await manager.RunOperation({
    operationName,
    item,
    isItem: true,
    isWarning: true,
    supressAllErrors: false,
  });
  if (!isSuccessfulResult(result)) {
    throw new Error(getResultMessage(result, fallbackMessage));
  }
  return {
    result,
    workspace: getFirstResultItem(result),
  };
};
